import { UnleashClient } from 'unleash-proxy-client';

import type { FeatureFlagClient, FeatureFlagConfig } from './types';

/**
 * The only module in this directory that names the Unleash SDK.
 *
 * `UnleashClient` structurally satisfies {@link FeatureFlagClient}; the
 * annotation is what keeps that true if either side changes.
 */
export const createUnleashClient = (config: FeatureFlagConfig): FeatureFlagClient =>
  new UnleashClient(config);
